import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { complianceAPI } from '../services/api';

/**
 * Compliance Dashboard panel — MiCA/CASP/VASP/Travel Rule control plane.
 */
const ComplianceDashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await complianceAPI.getDashboard();
        if (!cancelled) setData(res);
      } catch {
        if (!cancelled) setData(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!data?.success) {
    return (
      <div className="galaxia-card p-6">
        <h3 className="text-lg font-semibold text-galaxia mb-2">Compliance Control Plane</h3>
        <p className="text-sm text-galaxia-muted">Unable to load compliance dashboard.</p>
      </div>
    );
  }

  const modules = Object.entries(data.modules || {});

  return (
    <motion.div
      className="galaxia-card p-6"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <ShieldCheckIcon className="h-6 w-6" style={{ color: 'var(--galaxia-accent)' }} />
          <h3 className="text-lg font-semibold text-galaxia">Compliance Control Plane</h3>
        </div>
        <span className="text-sm font-mono" style={{ color: 'var(--galaxia-accent)' }}>
          Score {data.score}%
        </span>
      </div>
      <p className="text-sm text-galaxia-muted mb-4">
        Global regulatory posture (MiCA, CASP, VASP, Travel Rule, FinCEN, and partner jurisdictions).
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {modules.map(([key, mod]) => (
          <div
            key={key}
            className="rounded-xl p-3"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid var(--galaxia-border)' }}
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium capitalize text-galaxia">{key}</span>
              <span
                className={`text-xs px-2 py-0.5 rounded-full ${
                  mod.enabled ? 'galaxia-status-success' : 'galaxia-status-muted'
                }`}
              >
                {mod.enabled ? 'On' : 'Off'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default ComplianceDashboard;
